import { delay, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { PlatformService } from '@core/services/platform.service';
import { Request } from 'express';

@Component({
  selector: 'app-base',
  imports: [CommonModule],
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  currentPage = '/';
  footerHeight = 332;
  private footerResizeObserver: ResizeObserver | undefined;
  constructor(
    private eventEmitterService: EventEmitterService,
    private router: Router,
    private platformService: PlatformService,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject('request') private request: Request,
  ) {
    if (this.platformService.isBrowser()) {

      this.currentPage = window.location.pathname;

      //detect url path change, then update this.currentPage
      router.events.subscribe((val) => {
        this.currentPage = window.location.pathname;
      });
    } else if (this.request) {
      this.currentPage = this.request.path || '/';
    }
  }

  ngOnInit() {
    this.setFooterPadding(500);
    this.eventEmitterService.footerPaddingEmiter.subscribe((timer: number) => {
      this.setFooterPadding(timer);
    });
  }

  setFooterPadding(timer: number) {
    of(null).pipe(
      delay(timer), tap(() => {
        if (this.platformService.isBrowser()) {
          const footer = document.getElementsByTagName('footer')[0];
          if (footer) {
            this.footerHeight = footer.scrollHeight;
            this.observeFooter(footer);
          }
        }
      }
      )).subscribe();
  }

  private observeFooter(footer: HTMLElement) {
    if (this.footerResizeObserver || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.footerResizeObserver = new ResizeObserver(() => {
      this.footerHeight = footer.scrollHeight;
    });
    this.footerResizeObserver.observe(footer);
  }

}
